<template>
  <div class="list row">
    <div class="col-md-8 mr-4">
      <div class="input-group mb-3">
        <input type="text" v-validate="'required|min:1|max:75'" class="form-control mr-2" placeholder="Search by name" v-model="name"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="page = 1; retrieveProducts();"><font-awesome-icon icon="search" /> Search</button>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <button class="btn btn-primary" @click="newProduct"><font-awesome-icon icon="plus" /> Add Product</button>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-6">
      <h4><font-awesome-icon icon="list-alt" /> Products List</h4>
      <ul class="list-group">
        <li class="list-group-item" :class="{ active: index == currentIndex }" v-for="(product, index) in products" :key="index"  @click="setActiveProduct(product, index)">
          {{ product.name }} <span style="color: red;">|</span> {{ product.pv }}
        </li>
      </ul>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-md-6">
      <div v-if="currentProduct">
        <h4><font-awesome-icon icon="info-circle" /> Product Details</h4>
        <table class="table">
        <tr>
          <td><strong>Name:</strong></td><td> {{ currentProduct.name }}</td>
        </tr>
        <tr>
          <td><strong>SV:</strong></td><td> {{ currentProduct.sv }}</td>
        </tr>
        <tr>
          <td><strong>PV:</strong></td><td> {{ currentProduct.pv }}</td>
        </tr>
        <tr>
          <td><strong>Description:</strong></td><td> {{ currentProduct.description }}</td>
        </tr>
        <tr>
          <td><strong>Unit Price:</strong></td><td> {{ currentProduct.unitPrice }}</td>
        </tr>
        <tr>
          <td><strong>Cost Price:</strong></td><td> {{ currentProduct.costPrice }}</td>
        </tr>
        </table>

        <!-- <a class="m-3 btn btn-sm btn-warning" :href="'/products/' + currentProduct.id"><font-awesome-icon icon="edit" /> Edit </a>-->
        <router-link :to="{ path: '/products/' + currentProduct.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="edit" /> Edit </router-link>
      </div>
      <div v-else>
        <br />
        <p>Please click on a Product...</p>
      </div>
    </div>
  </div>
</template>

<script>
import ProductService from "../services/product.service";

export default {
  name: "products-list",
  data() {
    return {
      products: [],
      currentProduct: null,
      currentIndex: -1,
      name: "",

      page: 1,
      count: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15, 20, 25],
      loading: false
    };
  },
  methods: {
    /*retrieveProducts() {
      ProductService.getAll()
        .then(response => {
          this.products = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    retrieveProducts() {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      ProductService.getAllPageable(this.name, this.page, this.pageSize)
        .then(response => {
          const { products, totalItems } = response.data;
          this.products = products;
          this.count = totalItems;
          this.loading = false;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveProducts();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveProducts();
    },

    refreshList() {
      this.retrieveProducts();
      this.currentProduct = null;
      this.currentIndex = -1;
    },

    setActiveProduct(product, index) {
      this.currentProduct = product;
      this.currentIndex = index;
    },

    removeAllProducts() {
      ProductService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    /*searchName() {
      ProductService.getByName(this.name)
        .then(response => {
          this.products = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },*/

    newProduct() {
      this.$router.push('/addproduct');
    }
  },
  mounted() {
    this.retrieveProducts();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}
</style>